/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ready: NonNullable<unknown>, total: NonNullable<unknown> }} Cook_ReadyInputs */

const en_cook_ready = /** @type {(inputs: Cook_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ready} of ${i?.total} ready`)
};

const de_cook_ready = /** @type {(inputs: Cook_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ready} von ${i?.total} bereit`)
};

/**
* | output |
* | --- |
* | "{ready} of {total} ready" |
*
* @param {Cook_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_ready = /** @type {((inputs: Cook_ReadyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_ReadyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_ready(inputs)
	return en_cook_ready(inputs)
});